function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Mail_svg__clip0_1818_35649)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.375 4.375h-8.75a.625.625 0 000 1.25h6.929l-3.84 2.986L10.96 6.86l-.67 1.055 3.125 1.987a.622.622 0 00.719-.033l4.616-3.591v8.097h-8.125a.625.625 0 000 1.25h8.75c.345 0 .625-.28.625-.625V5a.625.625 0 00-.625-.625z",
  fill: "#1976D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.024.77a.614.614 0 00-.514-.133l-10 1.875a.623.623 0 00-.51.614v13.75c0 .3.214.559.51.614l10 1.875a.623.623 0 00.74-.614V1.25a.623.623 0 00-.226-.481z",
  fill: "#2196F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.625 14.375c-1.723 0-3.125-1.682-3.125-3.75s1.402-3.75 3.125-3.75 3.125 1.682 3.125 3.75-1.402 3.75-3.125 3.75zm0-6.25c-1.034 0-1.875 1.121-1.875 2.5s.841 2.5 1.875 2.5 1.875-1.121 1.875-2.5-.841-2.5-1.875-2.5z",
  fill: "#FAFAFA"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Mail_svg__clip0_1818_35649"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgMail;